module.exports = __webpack_public_path__ + "static/media/falseMirror.5122ec69.gif";